import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "../../../axios/axios";
import imageCompression from "browser-image-compression";
import { toast } from "react-toastify";
import SupplierNavbar from '../Admin/SuppplierNavbar';
import SupplierSidebar from '../Admin/SupplierSidebar';

function CreateRentalProduct() {
  const [rentalItem, setRentalItem] = useState("");
  const [partNo, setPartNo] = useState("");
  const [description, setDescription] = useState("");
const [sidebarOpen, setSidebarOpen] = useState(true);

  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [year, setYear] = useState("");

  const [rentalType, setRentalType] = useState("");
  const [rentPricePerDay, setRentPricePerDay] = useState("");
  const [rentPricePerWeek, setRentPricePerWeek] = useState("");
  const [rentPricePerMonth, setRentPricePerMonth] = useState("");
  const [depositAmount, setDepositAmount] = useState("");

  const [availabilityStatus, setAvailabilityStatus] = useState("Available");
  const [condition, setCondition] = useState("Good");
  const [manufactureDate, setManufactureDate] = useState("");

  const [features, setFeatures] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [inputValues, setInputValues] = useState({ feature: "", certification: "" });
  const [errors, setErrors] = useState({ feature: "", certification: "" });

  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);

  const [suppliers, setSuppliers] = useState([]);
  const [formData, setFormData] = useState({ selectedSupplier: {} });

  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [categories, setCategories] = useState([]);
  const [regions, setRegions] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [brandRes, modelRes, categoryRes, regionRes, supplierRes] = await Promise.all([
          Axios.get("/brands"),
          Axios.get("/models"),
          Axios.get("/categories"),
          Axios.get("/regions"),
          Axios.get("/supplier"),
        ]);

        setBrands(brandRes.data);
        setModels(modelRes.data);
        setCategories(categoryRes.data);
        setRegions(regionRes.data);
        setSuppliers(supplierRes.data.data);
      } catch (error) {
        console.error("Error fetching dropdowns:", error);
      }
    };
    fetchDropdownData();
  }, []);
useEffect(() => {
  const fetchLoggedInSupplier = async () => {
    try {
      const supplierInfo = JSON.parse(sessionStorage.getItem("supplierInfo"));

      if (!supplierInfo?.supplierId) {
        toast.error("Supplier information not found");
        return;
      }

      const response = await Axios.get(`/supplier/get/${supplierInfo.supplierId}`);
      const apiData = response.data?.data;

      setFormData((prev) => ({
        ...prev,
        selectedSupplier: {
          _id: apiData._id,
          supplierName: apiData.supplierName || "",
          address: apiData.address || "",
          phoneNumber: apiData.phoneNumber || "",
          emailAddress: apiData.emailAddress || "",
        },
      }));
    } catch (error) {
      toast.error("Failed to load supplier information");
    }
  };

  fetchLoggedInSupplier();
}, []);

  const handleAdd = (key) => {
    if (!inputValues[key]?.trim()) {
      setErrors({ ...errors, [key]: "Enter something!" });
      return;
    }

    if (key === "feature") {
      setFeatures([...features, inputValues[key]]);
    } else if (key === "certification") {
      setCertifications([...certifications, inputValues[key]]);
    }
    setInputValues({ ...inputValues, [key]: "" });
    setErrors({ ...errors, [key]: "" });
  };

  const handleRemove = (key, index) => {
    if (key === "feature") {
      setFeatures(features.filter((_, i) => i !== index));
    } else if (key === "certification") {
      setCertifications(certifications.filter((_, i) => i !== index));
    }
  };

  const uploadFileHandler = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    setUploading(true);

    try {
      const uploadedImages = await Promise.all(
        Array.from(files).map(async (file) => {
          const compressedFile = await imageCompression(file, {
            maxSizeMB: 0.2,
            maxWidthOrHeight: 800,
          });

          const formData = new FormData();
          formData.append("image", compressedFile);

          const { data } = await Axios.post("/upload-multiple", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          return { name: file.name, url: data.fileUrls[0] };
        })
      );

      setImages([...images, ...uploadedImages]);
    } catch (error) {
      toast.error("Failed to upload images");
    } finally {
      setUploading(false);
    }
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const handleSupplierChange = (e) => {
    const supplierId = e.target.value;
    const supplier = suppliers.find((sup) => sup._id === supplierId);
    setFormData((prev) => ({ ...prev, selectedSupplier: supplier || {} }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const supplierData = formData.selectedSupplier;
      const data = {
        rentalItem,
        partNo,
        description,
        brandId: selectedBrand,
        modelId: selectedModel,
        categoryId: selectedCategory,
        regionId: selectedRegion,
        year,
        rentalType,
        rentPricePerDay,
        rentPricePerWeek,
        rentPricePerMonth,
        depositAmount,
        availabilityStatus,
        condition,
        manufactureDate,
        features,
        certifications,
        images,
        supplier: {
          supplierId: supplierData._id,
          name: supplierData.supplierName,
          location: supplierData.address,
          contactNumber: supplierData.phoneNumber,
          email: supplierData.emailAddress,
        },
      };

      await Axios.post("/rental/create", data);
      toast.success("Rental item created successfully!");
      navigate("/SupplierProducts");
    } catch (error) {
      console.error("Error creating rental:", error);
      toast.error("Failed to create rental item");
    }
  };

  return (
       <div className="enhanced-body">
      <SupplierNavbar
        supplier={suppliers}
        setSupplier={setSuppliers}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar />
            </div>
          )}
          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
    <div className="row">
      <div className="col-12 grid-margin stretch-card">
        <div
                  className="card"
                  style={{
                    maxHeight: "95vh",
                    overflowY: "auto",
                    minHeight: "90vh",
                  }}
                >
        {/* <div className="card" style={{ maxHeight: "80vh", overflowY: "auto" }}> */}
          <div className="card-body">
            <h4 className="card-title">Create Rental Item</h4>
            <form className="forms-sample" onSubmit={handleSubmit}>
              
              {/* Item Name & Part No */}
              <div className="form-group">
                <label>Rental Item</label>
                <input type="text" className="form-control" value={rentalItem}
                  onChange={(e) => setRentalItem(e.target.value)} required />
              </div>
              <div className="form-group">
                <label>Part Number</label>
                <input type="text" className="form-control" value={partNo}
                  onChange={(e) => setPartNo(e.target.value)} required />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea className="form-control" rows="3" value={description}
                  onChange={(e) => setDescription(e.target.value)} />
              </div>

              {/* Brand / Model / Category / Region */}
              <div className="form-group">
                <label>Brand</label>
                <select className="form-control" value={selectedBrand}
                  onChange={(e) => setSelectedBrand(e.target.value)}>
                  <option value="">Select Brand</option>
                  {brands.map((b) => <option key={b._id} value={b._id}>{b.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Model</label>
                <select className="form-control" value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}>
                  <option value="">Select Model</option>
                  {models.map((m) => <option key={m._id} value={m._id}>{m.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Category</label>
                <select className="form-control" value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}>
                  <option value="">Select Category</option>
                  {categories.map((c) => <option key={c._id} value={c._id}>{c.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Region</label>
                <select className="form-control" value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}>
                  <option value="">Select Region</option>
                  {regions.map((r) => <option key={r._id} value={r._id}>{r.name}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Year</label>
                <input type="text" className="form-control"
                  value={year} onChange={(e) => setYear(e.target.value)} />
              </div>

              {/* Rental Prices */}
              <div className="form-group">
                <label>Rent Price Per Day</label>
                <input type="number" className="form-control"
                  value={rentPricePerDay} onChange={(e) => setRentPricePerDay(e.target.value)} required />
              </div>
              <div className="form-group">
                <label>Rent Price Per Week</label>
                <input type="number" className="form-control"
                  value={rentPricePerWeek} onChange={(e) => setRentPricePerWeek(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Rent Price Per Month</label>
                <input type="number" className="form-control"
                  value={rentPricePerMonth} onChange={(e) => setRentPricePerMonth(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Deposit Amount</label>
                <input type="number" className="form-control"
                  value={depositAmount} onChange={(e) => setDepositAmount(e.target.value)} />
              </div>

              {/* Rental Type */}
              <div className="form-group">
                <label>Rental Type</label>
                <select className="form-control" value={rentalType}
                  onChange={(e) => setRentalType(e.target.value)}>
                  <option value="">Select Rental Type</option>
                  {["Tools", "Machinery", "Vehicles", "Construction", "Electronics"].map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>

              {/* Availability & Condition */}
              <div className="form-group">
                <label>Availability</label>
                <select className="form-control" value={availabilityStatus}
                  onChange={(e) => setAvailabilityStatus(e.target.value)}>
                  <option>Available</option>
                  <option>Rented</option>
                  <option>Under Maintenance</option>
                </select>
              </div>
              <div className="form-group">
                <label>Condition</label>
                <select className="form-control" value={condition}
                  onChange={(e) => setCondition(e.target.value)}>
                  <option>New</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Needs Repair</option>
                </select>
              </div>

              <div className="form-group">
                <label>Manufacture Date</label>
                <input type="date" className="form-control"
                  value={manufactureDate} onChange={(e) => setManufactureDate(e.target.value)} />
              </div>

              {/* Features & Certifications */}
              <div className="form-group">
                <label>Features</label>
                <div className="d-flex">
                  <input type="text" className="form-control"
                    value={inputValues.feature}
                    onChange={(e) => setInputValues({ ...inputValues, feature: e.target.value })} />
                  <button type="button" className="btn btn-primary mx-2" onClick={() => handleAdd("feature")}>Add</button>
                </div>
                {features.map((f, i) => (
                  <div key={i}>{f} <button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemove("feature", i)}>Remove</button></div>
                ))}
              </div>

              <div className="form-group">
                <label>Certifications</label>
                <div className="d-flex">
                  <input type="text" className="form-control"
                    value={inputValues.certification}
                    onChange={(e) => setInputValues({ ...inputValues, certification: e.target.value })} />
                  <button type="button" className="btn btn-primary mx-2" onClick={() => handleAdd("certification")}>Add</button>
                </div>
                {certifications.map((c, i) => (
                  <div key={i}>{c} <button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemove("certification", i)}>Remove</button></div>
                ))}
              </div>

              {/* Image Upload */}
              <div className="form-group">
                <label>Images</label>
                <input type="file" multiple accept="image/*" onChange={uploadFileHandler} />
                {uploading && <p>Uploading...</p>}
                <div className="d-flex flex-wrap mt-2">
                  {images.map((img, i) => (
                    <div key={i} className="me-2">
                      <img src={img.url} alt={img.name} height="80" />
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => removeImage(i)}>Remove</button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Supplier */}
              <div className="form-group">
                <label>Supplier</label>
                <select className="form-control"
                  value={formData.selectedSupplier?._id || ""}
                  disabled 
                  onChange={handleSupplierChange}>
                  <option value="">Select Supplier</option>
                  {suppliers.map((sup) => (
                    <option key={sup._id} value={sup._id}>{sup.supplierName} </option>
                  ))}
                  
                </select>
                
              </div>

              <button type="submit" className="btn btn-primary">Submit</button>
              <button type="button" className="btn btn-danger" onClick={() => navigate("/rentals")}>Cancel</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
   </div>
    // </div>
  );
}

export default CreateRentalProduct;
